import { cn } from 'src/lib/utils';

type Props = {
  activityNotificationNode: React.ReactNode;
  disruptedAccessNotificationNode: React.ReactNode;
  className?: string;
};
const PartyNotificationSettings = ({ activityNotificationNode, disruptedAccessNotificationNode, className }: Props) => {
  return (
    <div className={cn('space-y-4', className)}>
      {activityNotificationNode}
      {disruptedAccessNotificationNode}
    </div>
  );
};

export default PartyNotificationSettings;
